export default __webpack_public_path__ + "static/media/manage_ico.6c324bbb.svg";